import React, { useEffect , useContext } from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import {Marker, Popup, useMap} from 'react-leaflet';
import { Context } from '../store/reducer';
import { Line } from "react-chartjs-2";

import m_rainfall_0 from '../assets/img/marker/weather/m_rainfall_0.png'
import m_rainfall_1 from '../assets/img/marker/weather/m_rainfall_1.png';
import m_rainfall_2 from '../assets/img/marker/weather/m_rainfall_2.png';
import m_rainfall_3 from '../assets/img/marker/weather/m_rainfall_3.png';
import m_rainfall_4 from '../assets/img/marker/weather/m_rainfall_4.png';
import m_rainfall_5 from '../assets/img/marker/weather/m_rainfall_5.png';
import m_rainfall_6 from '../assets/img/marker/weather/m_rainfall_6.png';
import m_rainfall_7 from '../assets/img/marker/weather/m_rainfall_7.png';
import hanrei_tooltip from '../assets/img/hanrei_tooltip.png';
import icon_info from '../assets/img/icon_info.png';

/**
 * 32: 河川管理情報システム 雨量日集計
 * @param options
 * @returns {null}
 * @constructor
 */
const Component = ({options}) => {

    const handleSpotData = (item) => {

        let ret = []

        ret.push(<dl className='dl-list is-modal-spot'><dt>データ種別</dt><dd>{item["station_type_label"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>事業所名</dt><dd>{item["office_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>データ所管</dt><dd>{item["department"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>水系名</dt><dd>{item["water_system_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>河川名</dt><dd>{item["river_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>観測所番号</dt><dd>{item["observatory_id"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>観測所名</dt><dd>{item["name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{item["lat"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{item["lng"]}</dd></dl>)

        return ret
    }

    const map = useMap()
    const { state } = useContext(Context);

    return Object.keys(state["vis_32"].data).map((key, index) => {
        
        const item = state["vis_32"].data[key];
        
        let labels = [];
        let value1_list = [];
        let value2_list = [];

        Object.keys(item.rain_list).map(key => {

            const rainData = item.rain_list[key];
            
            labels.push(rainData.datetime);
            value1_list.push(rainData.rain_value1);
            value2_list.push(rainData.rain_value2);
        })

        // 10分雨量の現在のスライダーの値
        const currentTenMinutesValue = value1_list[state.timeIdx] ? value1_list[state.timeIdx] : 0;

        // グレー
        let icon = m_rainfall_1

        if (currentTenMinutesValue === "**"
          || currentTenMinutesValue === "--"
          || currentTenMinutesValue === "") {
            // 欠測: グレー
            icon = m_rainfall_1

        } else if (currentTenMinutesValue === "MM"
          || currentTenMinutesValue === "CC") {
             // 閉局・メンテナンス: バツ付きグレー
            icon = m_rainfall_0
        } else if (currentTenMinutesValue < 1) {
            // 無効雨(1mm未満): 白
            icon = m_rainfall_2
        } else if (currentTenMinutesValue < 10) {
            // 10mm未満: 水色
            icon = m_rainfall_3
        } else if (currentTenMinutesValue < 20) {
            // 20mm未満: 青
            icon = m_rainfall_4
        } else if (currentTenMinutesValue < 30) {
            // 30mm未満: 黄色
            icon = m_rainfall_5
        } else if (currentTenMinutesValue < 40) {
            // 40mm未満: オレンジ
            icon = m_rainfall_6
        } else if (currentTenMinutesValue >= 40) {
            // 40mm以上: 赤
            icon = m_rainfall_7
        }

        // if (item["name"] === "小鳥原") {
        //     console.log("10分雨量", currentTenMinutesValue)
        //     console.log("item[\"name\"]", item["name"])
        //     console.log("icon", icon)
        // }
         
        const iconUrl = new L.Icon({
            iconUrl: icon,
            iconRetinaUrl: icon,
            iconSize: [35, 35],
            iconAnchor: [17, 23],
            popupAnchor: [0, -50]
        });
        

        return (
          <>
              <Marker
                position={[item.lat, item.lng]}
                icon={iconUrl}
              >
                  <Popup autoPan={false} minHeight={400} maxHeight={800} minWidth={600} closeOnClick>
                      
                      <div className={"modal-detail"}>
                      {
                          handleSpotData(item)
                      }

                      <div className="p-graph">
                          <div className="p-graph__main">
                              
                      <Line
                        height={400}
                        width={500}
                        data={{
                            "labels": labels,
                            "datasets": [
                                {
                                    type: "bar",
                                    yAxisID: 'y',
                                    "label": "10分雨量(mm)",
                                    "data": value1_list,
                                    "backgroundColor": "rgb(75, 192, 192, 0.7)"
                                },
                                {
                                    yAxisID: 'y2',
                                    "label": "累計雨量(mm)",
                                    "data": value2_list,
                                    "borderColor": "rgb(170,1,169, 0.8)"
                                }
                            ]
                        }}
                        options={{
                            // responsive: true,
                            maintainAspectRatio: true,
                            elements: {
                                point: {
                                    radius : function(context){
                                        return context.dataIndex === state.timeIdx ? 8 : 0
                                    },
                                }
                            },
                            scales: {
                             
                                y: {
                                    type: 'linear',
                                    display: true,
                                    position: 'left',
                                    max: 50,
                                },
                                y2: {
                                    type: 'linear',
                                    display: true,
                                    position: 'right',
                                    max: 500,
                                }
                            }
                        }}
                        id="chart-key"
                      />

                  </div>

                          <div className="p-graph__hanrei">
                              <div>
                                  <a href="" className="modal-link __ttl" onClick={e => {e.preventDefault(); return false;}} style={
                                      {
                                      '--hover-before-background': `url(${icon_info})`,
                                      '--hover-after-background': `url(${hanrei_tooltip})`
                                      }
                                  }>凡例について</a>
                              </div>

                      <div className="p-graph-hanrei">
                          <ul className="p-graph-hanrei__list">
                              <li><span className="pgh-item pgh-uryou"></span><span className="pgh-txt">10分雨量<span className="__sm">［mm］</span></span></li>
                              <li><span className="pgh-item pgh-ruikauryou"></span><span className="pgh-txt">累加雨量<span className="__sm">［mm］</span></span></li>
                          </ul>
                      </div>

                  </div>
              </div>
                          
                      </div>

                  </Popup>
              </Marker>

          </>
        );
    })
}

export default Component
